import { EnumOption } from './enum-option';

export const ProcessTemplateType = {
  EmploymentBased: 0,
  FamilyBased: 1,
  Other: 2
}

export const ProcessTemplateTypeList: EnumOption[] = [
  { value: ProcessTemplateType.EmploymentBased, label: 'Employment Based' },
  { value: ProcessTemplateType.FamilyBased, label: 'Family Based' },
  { value: ProcessTemplateType.Other, label: 'Other' }
];